import { Card } from "@heroui/react"
import classes from "../../styles/NewTeacher.module.scss"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import {
  editCategory,
  getCategoryById,
} from "../../utils/requests/knowladgebase"
import CategoryForm from "../../components/Knowladge/CategoryForm"

const EditCategory = () => {
  const [loading, setLoading] = useState(false)

  const [category, setCategory] = useState<Partial<KnowladgebaseCategory>>({})

  const navigate = useNavigate()
  const { id } = useParams()

  useEffect(() => {
    if (!id) {
      return
    }

    const fetchCategory = async () => {
      const fetchedCategory = await getCategoryById(id)
      setCategory(fetchedCategory)
    }

    fetchCategory()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const onSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    const { success } = await editCategory(category)
    setLoading(false)

    if (!success) {
      return
    }

    navigate(-1)
  }

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <CategoryForm
          loading={loading}
          onSubmit={onSubmit}
          values={category}
          onChange={setCategory}
          title="עריכת קטגוריה"
          ctaLabel="שמירה"
        />
      </Card>
    </div>
  )
}

export default EditCategory
